export default {
  props: {
    remoteNetWorks: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      // 网络质量
      remoteNetWorkAttrs: {},
      remoteNetWorkIconColor: '',
      netWork: {
        upLinkNetWork: '',
        downLinkNetWork: ''
      }
    };
  },
  computed: {
    bgColor() {
      if (this.remoteNetWorkIconColor === 'Green') {
        return 'bgGreen';
      } else if (this.remoteNetWorkIconColor === 'Orange') {
        return 'bgOrange';
      } else if (this.remoteNetWorkIconColor === 'Red') {
        return 'bgRed';
      } else {
        return '';
      }
    }
  },
  watch: {
    remoteNetWorks(newVal) {
      this.remoteNetWorkAttrs = this.remoteNetWorks;
      if (this.remoteNetWorkAttrs.uplinkNetworkQuality < 3) {
        this.netWork.upLinkNetWork = 'Good';
      } else if (this.remoteNetWorkAttrs.uplinkNetworkQuality > 4) {
        this.netWork.upLinkNetWork = 'Poor';
      } else {
        this.netWork.upLinkNetWork = 'Mid';
      }
      if (this.remoteNetWorkAttrs.downlinkNetworkQuality < 3) {
        this.netWork.downLinkNetWork = 'Good';
      } else if (this.remoteNetWorkAttrs.downlinkNetworkQuality > 4) {
        this.netWork.downLinkNetWork = 'Poor';
      } else {
        this.netWork.downLinkNetWork = 'Mid';
      }
      this.dealRemoteNetWorkQuality(this.netWork);
      this.$emit('callBack', this.remoteNetWorkIconColor);
    }
  },
  created() {},
  methods: {
    dealRemoteNetWorkQuality(remoteNetWork) {
      if (remoteNetWork.upLinkNetWork === 'Good' && remoteNetWork.upLinkNetWork === 'Good') {
        this.remoteNetWorkIconColor = 'Green';
      } else if (remoteNetWork.upLinkNetWork === 'Good' && remoteNetWork.downLinkNetWork === 'Mid') {
        this.remoteNetWorkIconColor = 'Orange';
      } else if (remoteNetWork.upLinkNetWork === 'Mid' && remoteNetWork.downLinkNetWork === 'Mid') {
        this.remoteNetWorkIconColor = 'Orange';
      } else if (remoteNetWork.upLinkNetWork === 'Poor' || remoteNetWork.downLinkNetWork === 'Poor') {
        this.remoteNetWorkIconColor = 'Red';
      }
    }
  }
};